@use "ui/styles/fonts";
@use "ui/styles/sizes";

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: fonts.$small;
  padding: sizes.$s6;
}

.builderList {
  padding: sizes.$s6;
}

.builderLogo {
  height: 100%;
}
